import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import Swup from 'swup';
import SwupScrollPlugin from '@swup/scroll-plugin';
import SwupPreloadPlugin from '@swup/preload-plugin';
import SwupSlideTheme from '@swup/slide-theme';
import SwupScriptsPlugin from '@swup/scripts-plugin';
import SwupHeadPlugin from '@swup/head-plugin';
import SwupA11yPlugin from '@swup/a11y-plugin';

UIkit.use(Icons);

const swup = new Swup({
    containers: ['#swup', '.site-footer-grid-headline', '.navbar-center li'],
    linkSelector:
        'a[href^="' +
        window.location.origin +
        '"]:not([data-no-swup]),' +
        'a[href^="/"]:not([data-no-swup]):not([target="_blank"]):not(.rex-minibar-close):not(.rex-minibar-opener),' +
        'a[href^="#"]:not([data-no-swup]):not([target="_blank"])',
    animateHistoryBrowsing: true,
    plugins: [
        new SwupScrollPlugin({
            animateScroll: false
        }),
        new SwupSlideTheme({
            reversed: true
        }),
        new SwupPreloadPlugin(),
        new SwupHeadPlugin(),
        new SwupA11yPlugin({
            announcementTemplate: "Navigiert zu: {title}",
            urlTemplate: "Neue Seite unter {url}"
        }),
        new SwupScriptsPlugin({
            head: true,
            body: false
        }),
    ]
});

window.addEventListener('load', init);
swup.on('pageView', init);
swup.on('animationOutStart', hideOffcanvas)
swup.on('samePage', hideOffcanvas);

function init() {
    let boxReloadLink = document.querySelector('.consent_manager-show-box-reload');

    if (boxReloadLink) {
        boxReloadLink.addEventListener('click', () => {
            consent_manager_parameters.forcereload = 1;
            consent_manager_showBox();
        })
    }

    /*Video Start*/

    const video = document.getElementById('video');
    const stopButton = document.getElementById('stopButton');
    if (video) {
        stopButton.addEventListener('click', function () {
            if (video.paused) {
                video.play();
                stopButton.classList.remove('paused');
            } else {
                video.pause();
                stopButton.classList.add('paused');
            }
        });
    }
    /*Video End*/
}

function hideOffcanvas() {
    UIkit.offcanvas('.mobile-navigation').hide();
}


/*Footer Accordion Start*/
function footerAcc() {
    const mobileAccordions = document.querySelectorAll('.site-footer-grid-headline');

    if (mobileAccordions) {
        mobileAccordions.forEach(function (mobileAccordion) {
            mobileAccordion.addEventListener('click', function () {
                const isActive = mobileAccordion.classList.contains('active');

                mobileAccordions.forEach(function (accordion) {
                    accordion.classList.remove('active');
                });
                if (!isActive) {
                    mobileAccordion.classList.add('active');
                }
            });
        });
    }
}
footerAcc();
document.addEventListener('swup:contentReplaced', footerAcc);
/*Footer Accordion End*/



/*Sidebar Start*/
function sideBarActive() {
    const sidebarLinks = document.querySelectorAll('.sidebar a');
    let clickedLink = null;

    function updateActiveLink() {
        const scrollPosition = window.scrollY;
        let activeLinkFound = false;

        document.querySelectorAll('.content-block').forEach(function (section) {
            const sectionId = section.getAttribute('id');
            const sectionOffset = section.offsetTop;
            const sectionHeight = section.offsetHeight;

            if (!activeLinkFound && scrollPosition >= sectionOffset && scrollPosition < sectionOffset + sectionHeight) {
                sidebarLinks.forEach(function (link) {
                    link.classList.remove('active');
                });
                const activeLink = document.querySelector('.sidebar a[href="#' + sectionId + '"]');
                if (activeLink) {
                    activeLink.classList.add('active');
                }
                activeLinkFound = true;
            }
        });
    }

    sidebarLinks.forEach(function (link) {
        link.addEventListener('click', function(e) {
            e.preventDefault(); // Prevent the default link behavior
            sidebarLinks.forEach(function (link) {
                link.classList.remove('active');
            });
            this.classList.add('active');
            clickedLink = this;

            // Scroll to the target section smoothly
            const targetId = this.getAttribute('href').substring(1); // Get the target section ID
            const targetSection = document.getElementById(targetId);

            if (targetSection) {
                targetSection.scrollIntoView({
                    behavior: 'smooth'
                });
                // Add a delay to clear the clickedLink variable
                setTimeout(function() {
                    clickedLink = null;
                }, 500);
            }
        });
    });

    window.addEventListener('scroll', function() {
        if (!clickedLink) {
            updateActiveLink();
        }
    });
}

sideBarActive();
document.addEventListener('swup:contentReplaced', sideBarActive);

/*Sidebar End*/

/*Mobile Dropdown Start*/
document.addEventListener('DOMContentLoaded', function () {
    function MobileActive() {
        const toggleLink = document.querySelector('.mobile-block-toggle-link');
        const dropdown = document.getElementById('toggle-dropdown');

        if (toggleLink) {
            toggleLink.addEventListener('click', function () {
                if (dropdown) {
                    if (dropdown.hasAttribute('hidden')) {
                        dropdown.removeAttribute('hidden');
                    } else {
                        dropdown.setAttribute('hidden', 'true');
                    }
                }
            });
        }

        if (dropdown) {
            const anchorLinks = dropdown.querySelectorAll('.scroll-to-anchor');

            anchorLinks.forEach(function (anchorLink) {
                anchorLink.addEventListener('click', function () {
                    if (!dropdown.hasAttribute('hidden')) {
                        dropdown.setAttribute('hidden', 'true');
                    }
                });
            });
        }
    }
    MobileActive();
    document.addEventListener('swup:contentReplaced', MobileActive);
});


/*Mobile Dropdown End*/


/*Voicess Start*/
function voices() {
    const voiceTabs = document.querySelectorAll('.voices-tab');
    const voiceContents = document.querySelectorAll('.voices-content');

    if (voiceContents.length > 0 && voiceTabs.length > 0) {
        voiceContents[0].style.display = 'block';
        voiceTabs[0].classList.add('active');

        voiceTabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                voiceContents.forEach((content) => {
                    content.style.display = 'none';
                });
                voiceTabs.forEach((tab) => {
                    tab.classList.remove('active');
                });
                if (voiceContents[index]) {
                    voiceContents[index].style.display = 'block';
                }
                tab.classList.add('active');
            });
        });
    }
    const moreLink = document.querySelector(".more-link");

    if (moreLink) {
        moreLink.addEventListener('click', function() {
            moreLink.classList.toggle('active');
            if (moreLink.classList.contains("active")) {
                moreLink.textContent = "weniger laden";
            } else {
                moreLink.textContent = "mehr laden";
            }
        });
    }
}
voices();
document.addEventListener('swup:contentReplaced', voices);
/*Voicess End*/



/*No Break Mobile Start*/
function noBreak() {
    function removeBreakTags() {
        if (window.innerWidth <= 640) {
            var elements = document.querySelectorAll('.no-mobile-break p');

            for (var i = 0; i < elements.length; i++) {
                var element = elements[i];
                var brTags = element.getElementsByTagName('br');

                for (var j = 0; j < brTags.length; j++) {
                    element.removeChild(brTags[j]);
                    // Hinzufügen eines Leerzeichens nach dem Entfernen von <br>
                    element.appendChild(document.createTextNode(' '));
                }
            }
        }
    }

    window.addEventListener('resize', removeBreakTags);
    removeBreakTags();
}
noBreak();
document.addEventListener('swup:contentReplaced', noBreak);
/*No Break Mobile End*/
